import { render, staticRenderFns } from "./WsDialog.vue?vue&type=template&id=a23cb0fc&"
import script from "./WsDialog.vue?vue&type=script&lang=js&"
export * from "./WsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports